<div class="card">
  <p class="card__title" id="schedule-progress-title">{{ "schedule.services" | translate }}</p>
  @if (schedule.modality !== modalityEnum.DEALER) {
  <span class="card__pud-tag">
    {{ "remote-experience.title." + schedule.modality | lowercase | translate }}
  </span>
  }

  <!-- schedule: hora, data e nome do dealer -->
  <div class="card__schedule-info">
    <span id="schedule-date-hour">{{ schedule.dateAndHour }}</span>
    <span id="schedule-dealerName">{{ schedule.dealerName | titlecase }}</span>
  </div>

  <div class="payment-wrapper">
    <!-- status de pagamento -->
    @if (schedule.paymentMethod?.[0]?.status) {
    <app-ui-status-payment [paymentDTO]="schedule.paymentMethod[0]" [alignCenter]="true" />

    <!--Cenário Error Payment Status -->
    @if (hasErrorPayment) {
    <app-ui-alert-information [alertType]="'warning'"
      [message]="'schedule.payment.alert.card.content.error' | translate" [iconType]="'small'" />
    }
    }
  </div>

  <hr class="card__diviser">
  @if (schedule.modality !== modalityEnum.DEALER) {
  <div class="card-driver">
    <app-driver-information [payloadDriver]="payloadDriver" [modality]="schedule.modality" />
  </div>
  }
  <!-- botoes  -->
  <div class="card__schedule-nav">
    <button class="card__schedule-nav__button" id="btn-details" (click)="goToDetails()">
      {{ "schedule.details" | translate }}
      <img src="../assets/lib/icons/Icon_Arrow-small.svg" alt="go to details">
    </button>
    
    <button 
      class="card__schedule-nav__button" 
      id="btn-reschedule" 
      (click)="openRescheduleDialog(schedule)">
      {{ "schedule.reschedule" | translate }}
      <img src="../assets/lib/icons/Icon_Arrow-small.svg" alt="go to reschedule">
    </button>
    
    <button class="card__schedule-nav__button" id="btn-cancel" (click)="openCancelDialog(schedule)">
      {{ "schedule.cancel" | translate }}
      <img src="../assets/lib/icons/Icon_Arrow-small.svg" alt="go to cancel">
    </button>
  </div>
</div>

<div id="modal">
  <app-dialog [opened]="cancelDialogChange" (openedChange)="closeCancelDialog()" [modalCenter]="true">
    @if (!loadingCancel) {
    <p class="modal-cancel__title">{{ "commom.attention" | translate }}</p>
    }
    @if (loadingCancel) {
    <p class="modal-cancel__title">{{ "commom.canceling" | translate }}</p>
    <div class="modal-cancel__loading-cancel">
      <circular-indicator />
    </div>
    }
    @if (!loadingCancel) {
    <div class="modal-content">
      <p>
        @if (hasOnlinePayment) {
        {{ "modal-payment.confirm-cancel-subtitle" | translate }}
        <br>
        <br>
        {{ "modal-payment.confirm-cancel-text" | translate }}
        } @else {
        {{ "modal.confirm-cancel" | translate }}
        }
      </p>
    </div>

    <div class="modal-cancel__buttons">
      <a class="modal-cancel__buttons__button-reverse" (click)="closeCancelDialog()" href="javascript:void(0)"
        id="modal-btn-close">
        {{ 'commom.no' | translate }}
        <img src="../assets/lib/icons/Icon_Arrow-small.svg" style="transform: rotateY(180deg);" alt="Arrow">
      </a>
      <lib-button type="primary" [rightIcon]="true" id="modal-btn-cancel" (clickButton)="performCancelAndReschedule(scheduleToCancel, true)">
        {{ 'commom.yes' | translate }}
      </lib-button>
    </div>
    }
  </app-dialog>

  <app-dialog [opened]="rescheduleDialogChange" (openedChange)="closeRescheduleDialog()" [modalCenter]="true">
    <p class="modal__title">{{ "schedule.reschedule-title" | translate }}</p>
    <p>{{ "schedule.reschedule-description" | translate }}</p>

    <div class="modal__buttons">
      <lib-button type="primary" [rightIcon]="true" id="modal-btn-reschedule" (clickButton)="performCancelAndReschedule(scheduleToCancel)">
        {{ 'schedule.edit-schedule' | translate }}
      </lib-button>
    </div>
  </app-dialog>

  <app-dialog [opened]="rescheduleUnavailableDialogChange" (openedChange)="closeRescheduleUnavailableDialog()"
    [modalCenter]="true">
    <p class="modal__title">{{ "schedule.reschedule-unavailable-title" | translate }}</p>
    <p class="modal__description">{{ "schedule.reschedule-unavailable-description" | translate }}</p>
    <p class="modal__subdescription">{{ "schedule.reschedule-unavailable-subdescription" | translate }}</p>

    <div class="modal__buttons">
      <lib-button type="primary" id="modal-btn-reschedule-unavailable" (clickButton)="closeRescheduleUnavailableDialog()">
        {{ 'schedule.understood' | translate }}
      </lib-button>
    </div>
  </app-dialog>
</div>
